import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "@/auth/store/authSlice";
import themeReducer from "@/theme/store/themeSlice";
import academicsReducer from "@/modules/institutionAdmin/academics/store/academicsSlice";
import timetableReducer from "@/modules/institutionAdmin/timetable/store/timetableSlice";
import staffReducer from "../modules/institutionAdmin/staff/store/staff.slice";
import cmsHeroReducer from "@/modules/superAdmin/cms/hero/store/heroSlice";
import cmsChallengesReducer from "@/modules/superAdmin/cms/challenges/store/challengesSlice";
import cmsPricingReducer from "@/modules/superAdmin/cms/pricing/store/pricingSlice";
import cmsTestimonialsReducer from "@/modules/superAdmin/cms/testimonials/store/testimonialsSlice";
import cmsFaqReducer from "@/modules/superAdmin/cms/faq/store/faqSlice";
import cmsSocialLinksReducer from "@/modules/superAdmin/cms/socialLinks/store/socialLinksSlice";
import cmsBlogReducer from "@/modules/superAdmin/cms/blog/store/blogSlice";
import cmsPagesReducer from "@/modules/superAdmin/cms/pages/store/pagesSlice";
import landingHeroReducer from "@/landing/store/heroSlice";
import landingChallengesReducer from "@/landing/store/challengesSlice";
import landingPricingReducer from "@/landing/store/pricingSlice";
import landingTestimonialsReducer from "@/landing/store/testimonialsSlice";
import landingFaqReducer from "@/landing/store/faqSlice";
import landingBlogReducer from "@/landing/store/blogSlice";
import superAdminDashboardReducer from "@/modules/superAdmin/dashboard/store/dashboardSlice";
import orgDashboardReducer from "@/modules/orgAdmin/dashboard/store/orgDashboardSlice";
import institutionDashboardReducer from "@/modules/institutionAdmin/dashboard/store/dashboardSlice";
import subjectReducer from "@/modules/superAdmin/subjects/store/subjectSlice";
import feeCategoryReducer from "@/modules/superAdmin/feeCategories/store/feeCategorySlice";
import whatsappReducer from "@/modules/superAdmin/whatsapp/store/whatsappSlice";
import academicStructureTemplateReducer from "../modules/superAdmin/academicSetup/templates/store/templateSlice";
import academicGroupTypeReducer from "@/modules/superAdmin/academicSetup/types/store/groupTypeSlice";
import academicMasterNameReducer from "@/modules/superAdmin/academicSetup/masterNames/store/masterNameSlice";
import languageReducer from "@/modules/shared/language/store/languageSlice";
import orgTreeReducer from "@/modules/superAdmin/orgManagement/store/orgTreeSlice";
import organizationsReducer from "@/modules/superAdmin/orgManagement/store/organizationsSlice";
import campusesReducer from "@/modules/superAdmin/orgManagement/store/campusesSlice";
import feesReducer from "@/modules/institutionAdmin/fees/store/feesSlice";
import admissionsReducer from "@/modules/institutionAdmin/admissions/store/admissionsSlice";
import admissionApplicationsReducer from "@/modules/institutionAdmin/admissions/store/admissionApplicationsSlice";
import attendanceReducer from "@/modules/institutionAdmin/attendance/store/attendanceSlice";
import staffAttendanceReducer from "@/modules/institutionAdmin/staffAttendance/store/staffAttendanceSlice";
import libraryReducer from "@/modules/institutionAdmin/facilities/library/store/librarySlice";
import transportReducer from "@/modules/institutionAdmin/facilities/transport/store/transportSlice";
import hostelReducer from "@/modules/institutionAdmin/facilities/hostel/store/hostelSlice";
import inventoryReducer from "@/modules/institutionAdmin/facilities/inventory/store/inventorySlice";
import sharedAcademicYearReducer from "@/modules/institutionAdmin/shared/academicYear/store/academicYearSlice";
import studentsReducer from "@/modules/institutionAdmin/students/store/studentsSlice";
import promotionsReducer from "@/modules/institutionAdmin/promotions/store/promotionsSlice";
import studentCategoryReducer from "@/modules/superAdmin/studentCategories/store/studentCategorySlice";
import syllabusReducer from "@/modules/institutionAdmin/syllabus/store/syllabusSlice";




export const rootReducer = combineReducers({
  auth: authReducer,
  theme: themeReducer,
  academics: academicsReducer,
  timetable: timetableReducer,
  staff: staffReducer,
  cmsHero: cmsHeroReducer,
  cmsChallenges: cmsChallengesReducer,
  cmsPricing: cmsPricingReducer,
  cmsTestimonials: cmsTestimonialsReducer,
  cmsFaq: cmsFaqReducer,
  cmsSocialLinks: cmsSocialLinksReducer,
  cmsBlog: cmsBlogReducer,
  cmsPages: cmsPagesReducer,
  landingHero: landingHeroReducer,
  landingChallenges: landingChallengesReducer,
  landingPricing: landingPricingReducer,
  landingTestimonials: landingTestimonialsReducer,
  landingFaq: landingFaqReducer,
  landingBlog: landingBlogReducer,
  superAdminDashboard: superAdminDashboardReducer,
   orgDashboard: orgDashboardReducer,
   institutionDashboard: institutionDashboardReducer,
     subjects: subjectReducer,
     feeCategories: feeCategoryReducer,
     whatsapp: whatsappReducer,
  academicStructureTemplates: academicStructureTemplateReducer,
    academicGroupTypes: academicGroupTypeReducer,
    academicMasterNames: academicMasterNameReducer,
    language: languageReducer,
    orgTree: orgTreeReducer,
    organizations: organizationsReducer,
    campuses: campusesReducer,
    fees: feesReducer,
    admissions: admissionsReducer,
    admissionApplications: admissionApplicationsReducer,
    attendance: attendanceReducer,
    staffAttendance: staffAttendanceReducer,
    library: libraryReducer,
    transport: transportReducer,
    hostel: hostelReducer,
    inventory: inventoryReducer,
    sharedAcademicYear: sharedAcademicYearReducer,
    students: studentsReducer,
    promotions: promotionsReducer,
    studentCategories: studentCategoryReducer,
    syllabus: syllabusReducer,
});